/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023, 2024.
 */

import { getProduct } from '@/data/Content/Product';
import { getPromoMessage } from '@/data/Content/PromoMessage';
import { getStoreLocale } from '@/data/Content/StoreLocale-Server';
import { ESpotContainerType, getESpotDataFromName } from '@/data/Content/_ESpotDataFromName';
import { getLocalization } from '@/data/Localization';

import { useFeaturedProductRecommendation } from '@/core/data/Content/FeaturedProductRecommendation';
import { getSettings } from '@/data/Settings';
import { ContentProps } from '@/data/types/ContentProps';

const dataMap = (spots?: ESpotContainerType): string =>
	spots?.MarketingSpotData?.at(0)?.baseMarketingSpotActivityData?.at(0)?.productPartNumber || '';

const getFeaturedProductRecommendation = async ({
	cache,
	id: _id,
	context,
	properties,
}: ContentProps) => {
	const spot = await getESpotDataFromName(cache, properties?.emsName ?? '', context);
	if (spot) {
		const { localeName: locale } = await getStoreLocale({ cache, context });
		const productPartNumber = dataMap(spot);
		const product = await getProduct(cache, productPartNumber, context);
		await getLocalization(cache, locale, 'FeaturedCard');
		const settings = await getSettings(cache, context);
		const isFetchPromoEnabled = settings.userData.ENABLE_API_CALL_FETCH_PROMO;
		isFetchPromoEnabled && product && (await getPromoMessage(cache, context, product.id));
	}
};

export { getFeaturedProductRecommendation, useFeaturedProductRecommendation };
